import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomModal from '../../../../Elements/modal/CustomModal'
import TextInput from '../../../../Elements/inputs/TextInput'
import FormControls from '../../../../Elements/form/FormControls'
import Loader from '../../../../Elements/loaders'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { setCashBookNewLoading } from '../../../../../redux/action/cashbookNew'
import { initialBalanceForCashBookThunk } from '../../../../../redux/thunk/cashBookNew'
import { EnterFirstBalanceModalContent, EnterFirstBalanceModalText, EnterFirstBalanceModalWrap, ErrorMessageText, ErrorMessageWrap } from './index.styled'
import MainIcon from '../../../../../img/svg/main'

const EVENT_Z_INDEX = 26

const regexOnlyPositiveNumbers = /^([1-9]\d*)([.,]\d+)?$/

const defaultValues = { initialBalance: '' }

const EnterFirstBalanceModal = React.memo(({ showModal, setShowModal, handleShowMoneyExchangeModal }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { register, handleSubmit, formState: { errors }, watch, setValue, reset } = useForm()

	const loading = useSelector(store => store.cashbookNew.loading)

	const handleReset = useCallback(() => {
		reset(defaultValues)
	}, [reset])

	const handleClose = useCallback(() => {
		setShowModal(false)
		handleReset()
	}, [setShowModal, handleReset])

	const onSubmit = (data) => {
		dispatch(setCashBookNewLoading(true))
		dispatch(initialBalanceForCashBookThunk(data, handleShowMoneyExchangeModal()))
	}

	const handleOnBlur = () => {
		const value = +watch('initialBalance')
		const formattedValue = value.toFixed(2)
		setValue('initialBalance', formattedValue)
	}

	return (
		<CustomModal isOpen={showModal}
								 close={handleClose}
								 size="small"
								 zIndex={EVENT_Z_INDEX}
								 title={t('cashBook.form.initialBalance')}>
			<form onSubmit={handleSubmit(onSubmit)}>
				{!loading ?
					<EnterFirstBalanceModalWrap>
						<EnterFirstBalanceModalContent>
							<EnterFirstBalanceModalText>{t('cashBook.modal.enterFirstBalance')}.</EnterFirstBalanceModalText>
							<TextInput name="initialBalance"
												 label={t('cashBook.form.initialBalance')}
												 className="numberWithoutArrow"
												 testId="initialBalance"
												 type="number"
												 register={register}
												 watch={watch}
												 errors={errors}
												 options={{
													 required: t('cashBook.form.validation.required'),
													 pattern: {
														 value: regexOnlyPositiveNumbers,
														 message: t('cashBook.form.validation.positive_number')
													 }
												 }}
												 onBlur={handleOnBlur}
												 color="gray" />
						</EnterFirstBalanceModalContent>
						<ErrorMessageWrap>
							<MainIcon icon="info" />
							<ErrorMessageText>
								{t('cashBook.moneyExchangeError')}
							</ErrorMessageText>
						</ErrorMessageWrap>
					</EnterFirstBalanceModalWrap>
					: <Loader color="gray" />}
				<FormControls {...{ handleSubmit: handleSubmit(onSubmit), handleReset, zIndex: 26, submitDisabled: !watch('initialBalance') }} />
			</form>
		</CustomModal>
	)
})

EnterFirstBalanceModal.displayName = 'EnterFirstBalanceModal'
export default EnterFirstBalanceModal
